import React from "react";
import { CreditCard } from "lucide-react";
import { useCcNotice } from "../lib/notice";

export function CreditNotice({ placement, variant = "inline", className = "" }) {
  const notice = useCcNotice();
  if (!notice?.enabled) return null;
  if (placement && notice.show && notice.show[placement] === false) return null;
  const text = notice.text || "3% EXTRA ON ALL CREDIT CARD PURCHASES";

  if (variant === "banner") {
    return (
      <section className={`max-w-7xl mx-auto px-4 sm:px-6 ${className}`} data-testid="cc-notice-banner">
        <div className={`border-2 border-[#cdb87a] bg-[#faf7f0] py-7 sm:py-9 px-5 text-center ${notice.animate !== false ? "cc-glow" : ""}`}>
          <p className="flex flex-wrap items-center justify-center gap-3 font-bold text-[#171310] text-base sm:text-2xl tracking-[0.12em] sm:tracking-[0.16em] uppercase">
            <CreditCard size={22} className="text-[#a8842c] shrink-0" aria-hidden="true" />
            <span>{text}</span>
          </p>
        </div>
      </section>
    );
  }

  if (variant === "footer") {
    return (
      <p className="font-bold text-[#171310] text-xs sm:text-sm tracking-[0.15em] uppercase" data-testid="cc-notice-footer">
        {text}
      </p>
    );
  }

  return (
    <p className={`flex items-center gap-2 font-bold text-[#171310] text-xs sm:text-sm tracking-wide uppercase ${className}`} data-testid={`cc-notice-${placement || "inline"}`}>
      <CreditCard size={15} className="text-[#a8842c] shrink-0" aria-hidden="true" />
      <span>{text}</span>
    </p>
  );
}
